import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { HTTPS, RequestStatus } from "../../../utils/common";
import { Country, State } from "../../../utils/apis/common/index";
import { Context } from "../../../utils/context";
import { Status } from "../../../utils/apis/wallet_management/wallet_hisory/wallet_history";
import Select from "react-select";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
function Add(props) {
  const { UnauthorizedLogOut, Select2Data } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    control,
    setValue,
  } = useForm();
  const onSubmit = async (data) => {
    try {
      const val = {
        status: 0,
        status_id: RequestStatus.Rejected,
        remark: data?.name,
      };
      const response = await Status(props?.show, val);
      if (response?.data?.success) {
        await setShowModal({
          code: response.data.code,
          message: response.data.data,
        });
        setTimeout(() => {
          setShowModal(0);
          props.onHide();
          reset();
        }, 1000);
      } else {
        setError("name", {
          message: response?.data?.errors?.name?.msg,
        });
      }
    } catch (error) {
      setError("name", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);

      console.error(error.message);
    }
  };

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal_Heading modalHeading={"Add Remark"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Remark*</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Remark"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "Remark is required",
                          })}
                        />
                        {errors.name && (
                          <span className="text-danger">
                            {errors.name.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="row">
                    <div className="col-md-6 col-sm-6 col-6 ">
                      <Button
                        className="search-btn"
                        onClick={() => {
                          props.onHide();
                          reset();
                        }}
                      >
                        Cancel
                      </Button>
                    </div>

                    <div className="col-md-6 col-sm-6 col-6">
                      <Button
                        className="reset-btn "
                        type="button"
                        onClick={handleSubmit(onSubmit)}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Add;
